import React, { useEffect, useState } from "react";
import { Card, Col, Row, OverlayTrigger, Popover } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./regularhowmuchcash.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import dayjs from "dayjs";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useSelector } from "react-redux";
import { addCommas } from "../../helpers/helpers";

export const RegularHowMuchCash = (props) => {
  const { choose } = useSelector(
    (state) => state.retirementApplication, // eslint-disable-line
  );
  const [sliderValue, setSliderValue] = useState(0);

  const detailsData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;

  const totalCash =
    Object.keys(choose).length === 0
      ? detailsData?.monetaryChosenAmount
      : choose?.monetaryChosenAmount; // eslint-disable-line

  const takingAsTaxFreeCash = addCommas(
    (totalCash * (sliderValue / 100)).toFixed(2), // eslint-disable-line
  );

  const movingToDrawdown = addCommas(
    (totalCash - totalCash * (sliderValue / 100)).toFixed(2), //eslint-disable-line
  );

  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");

  const handleSliderChange = (e) => {
    const percentage = parseFloat(e.target.value);
    setSliderValue(percentage);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace("%", "");
    if (inputValue === "") {
      setSliderValue("0");
    } else {
      const percentage = parseFloat(inputValue);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 25) {
        setSliderValue(percentage);
      }
    }
  };

  useEffect(() => {
    updateSliderBackground(sliderValue);
  }, [sliderValue]);

  const updateSliderBackground = (value) => {
    const percentage = (value / 25) * 100;
    const slider = document.querySelector(".custom-slider");
    slider.style.background = `linear-gradient(to right, var(--blue-100) 0%, var(--blue-100) ${percentage}%, var(--white) ${percentage}%, var(--white) 100%)`;
  };

  const handleBack = () => {
    props.makeInitialStepper(false, 33, { isRetirementChoice: true }, true);
  };
  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_RI_CASH_LUMPSUM;
    let regularIncome = {
      percentage: parseFloat(sliderValue),
    };
    let riData = {
      totalCash,
      movingToDrawdown,
      takingAsTaxFreeCash,
    };
    let payload = {
      currentStep,
      choiceCategory: { regularIncome },
      riData,
    };
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_RI_CASH_LUMPSUM,
      payload, // eslint-disable-line
    );
  };

  return (
    <>
      <Card className="application-step">
        <Card.Body className="how-much-cash">
          <h2 className="heading">How much cash would you like to take?</h2>
          <p>
            You can take <b>25% tax-free</b> and anything over that will be
            taxed.
          </p>
          <p>
            Use the slider or form field below to let us know how much you’d
            like to take as a tax-free cash lump sum.
          </p>
          <Card className="bottom-bg-card mb-5">
            <Card.Body>
              <Row className="bottom-card-content">
                <Col md={6}>
                  <p>
                    <span className="left-txt">
                      Let us know the tax-free cash lump sum you wish to take
                      (up to 25%) by entering the percentage or using the
                      slider.
                    </span>{" "}
                  </p>
                  <p className="form-field taking-cash">
                    <span>Taking as cash</span>
                    <input
                      type="text"
                      className="input-text"
                      value={`${sliderValue}%`}
                      onChange={handleInputChange}
                      min="0"
                      max="100"
                    />
                  </p>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={8} className="text-left">
                      <p>Applying with</p>
                      <p>Taking as tax-free cash</p>
                      <p>Moving to drawdown</p>
                    </Col>
                    <Col md={4} className="text-right bld p-0">
                      <p>{"£" + addCommas(totalCash)}</p>
                      <p>{"£" + takingAsTaxFreeCash}</p>
                      <p>{"£" + movingToDrawdown}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div>
                <p className="slider-value">
                  <span className="static">0%</span>
                  <span className="static text-right">25%</span>
                </p>
                <Form.Range
                  value={sliderValue}
                  min="0"
                  max="25"
                  className="custom-slider"
                  onChange={handleSliderChange}
                />
              </div>
              <div className=" m-42 d-flex align-items-center justify-content-end">
                <div className="d-flex align-items-center">
                  <div className="value-correct-date mr-2">
                    {" "}
                    Values correct as of {todayDate}
                  </div>

                  <OverlayTrigger
                    placement="auto"
                    overlay={
                      <Popover
                        id="popover-contained"
                        className="tooltip-popover-section custom-popover"
                      >
                        <Popover.Body className="tooltip-popover-body-how-much-cash">
                          <p>
                            {" "}
                            All the values are estimates, based on the most
                            accurate information available. They include all the
                            contributions paid by you and your employer.
                          </p>
                          <p>
                            The value of your pension savings is based on
                            current financial conditions and is not guaranteed.
                            The amounts you receive may be higher or lower than
                            the amounts shown above. Payment of your pension
                            will be subject to TPT’s Trust Deed and Rules, and
                            regulatory requirements.
                          </p>{" "}
                        </Popover.Body>
                      </Popover>
                    }
                    flip={true}
                  >
                    <span className="textarea-tooltip">
                      <Icons iconname="tool-tip" variant="icon-twelve-px" />
                    </span>
                  </OverlayTrigger>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Row className="button-container">
            <Col md={6}>
              {" "}
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />
            </Col>
            <Col md={6} className="text-end">
              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
export default RegularHowMuchCash;
